import { Button } from '@mui/material'
import Typography from '@mui/material/Typography'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { useProfileStore } from '../../store/storeProfile'

export const StorageBuyDialog = ({ storage, open, handleClose, handleSubmit }) => {
    const { isLoadingCreateStorageTariffUser } = useProfileStore((state) => state)

    return (
        <ModalDialogWrapper
            footerActions={
                <>
                    <Button variant="outlined" fullWidth onClick={handleClose}>
                        Отменить
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        fullWidth
                        disabled={isLoadingCreateStorageTariffUser}>
                        Подключить
                    </Button>
                </>
            }
            colorSubmitButton="secondary"
            variantCloseButton="contained"
            open={open}
            handleClose={handleClose}
            title={`Подключить пакет «${storage.name}» (${storage.storage_gb} ГБ)?`}>
            <Typography variant="body2">
                С вашего баланса будет списываться {storage.price_coins} коинов в{' '}
                {storage.period === 'YEAR' ? 'год' : 'месяц'}
            </Typography>
        </ModalDialogWrapper>
    )
}
